import './App.css';
import { MachineContainer } from '../machineContainer/MachineContainer';

function App() {
  return (
    <div className="App">
      <MachineContainer />
    </div>
  );
}

export default App;
